import type { Content, WithCampaignContentId } from '@sparted/shared-library/business/types';

import type { Campaign, CampaignFromApi, PartialContent } from './activity.type';

export const fromApiCampaignMapper = (campaign: CampaignFromApi): Campaign => {
  return {
    ...campaign,
    scheduling: {
      ...campaign.scheduling,
      contents: campaign?.scheduling?.contents?.map(fromContentToPartialContent),
      orderedSessions: campaign?.scheduling?.orderedSessions?.map((session) =>
        session.map(fromContentToPartialContent),
      ),
    },
  };
};

export const fromContentToPartialContent = (content: WithCampaignContentId<Content>): PartialContent => {
  return {
    campaignContentId: content.campaignContentId,
    id: content.id,
    gameType: content.game?.type,
    coverImage: content.metadata?.coverImage,
    name: content.metadata.name,
    identifier: content.metadata.identifier,
    statuses: content.statuses,
    archived: content.archived,
  };
};
